import React from 'react';
import { RenderFunction } from 'types';

export function isRenderFunction<T extends unknown[]>(
  val: React.ReactNode | RenderFunction<T>,
): val is RenderFunction<T> {
  return typeof val === 'function';
}

export function renderComponentOrNode(
  Value: React.FunctionComponent | React.ReactNode,
): React.ReactNode {
  if (typeof Value === 'function') {
    return <Value />;
  }

  return Value;
}
